module.exports = __webpack_public_path__ + "img/LOLY-SELE.0b6c4725.jpg";